import { Product } from '~/commons/interfaces/models/content/product/Product'
import { isValueEnabled } from '~/helpers'

export function isProductManufacturerPrio(product: Product): boolean {
  return isValueEnabled(
    // @ts-ignore
    product.manufacturer?.translated?.customFields?.bs_prio_manufacturer
  )
}
